import { ExternalLink } from "lucide-react";

const pretty = (value) => {
  if (!value) return "";
  const iso = new Date(value);
  if (!Number.isNaN(iso.getTime()))
    return iso.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  return String(value);
};

/** The "as at" stamp that sits next to a headline figure: source, date and how it is refreshed. */
export const AsOf = ({ publisher, url, asOf, kind, testId }) => (
  <span
    className="mono mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500"
    data-testid={testId}
  >
    {kind ? (
      <span className={kind === "estimate" ? "text-ochre" : "text-zinc-400"}>{kind}</span>
    ) : null}
    {asOf ? <span>as at {pretty(asOf)}</span> : null}
    {publisher ? (
      url ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-zinc-400 underline decoration-zinc-700 underline-offset-2 hover:text-ochre"
        >
          {publisher} <ExternalLink size={9} />
        </a>
      ) : (
        <span>{publisher}</span>
      )
    ) : null}
  </span>
);

/** The FX stamp every page that prints shillings should carry. */
export const FxStamp = ({ fx, testId = "fx-stamp" }) =>
  fx?.kes_per_usd ? (
    <AsOf
      testId={testId}
      kind="official"
      asOf={fx.as_of}
      publisher={`KSh ${Math.round(fx.kes_per_usd)} to US$1 · ${fx.source}`}
      url={fx.url}
    />
  ) : null;
